import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import ButtonLink from "../../components/Button";
import MainMeta from '../../metaTags/MainMeta';

import Banner from "../../assets/images/IMG_2.png"

import "../../style/title.scss";
import "./index.scss";

function Contacts(){
    const { t } = useTranslation();
    const { lang } = useParams(); 
    
    const images = [Banner];
  const [loadedImages, setLoadedImages] = useState({}); 

  const handleImageLoad = (src) => {
    setLoadedImages((prev) => ({ ...prev, [src]: true })); 
  };

  return(
        <div className="contacts-wrapper">
            <MainMeta />
            <div className='title'>
                <div className='text big'>{t('contacts')}</div>
            </div>
            <div className="contact-info">
                <div className="part adress">
                    <div className="icon map"></div>
                    <span>Stationsweg 14, 1815CC</span>
                    <span>{t('alkmaar')}, {t('nederlands')}</span>
                </div>
                <div className="part phone">
                    <div className="icon phone"></div>
                    <span>072 5203013</span>
                </div>
                <div className="part mail">
                    <div className="icon mail"></div>
                    <a href="mailto:&#105;&#110;&#102;&#111;&#64;&#98;&#111;&#114;&#115;&#99;&#104;&#116;&#46;&#110;&#108;">&#105;&#110;&#102;&#111;&#64;&#98;&#111;&#114;&#115;&#99;&#104;&#116;&#46;&#110;&#108;</a>
                    <span>KvK: 78014220</span>
                </div>
            </div> 
            <div className='banner'>
                {!loadedImages[Banner] && <div className="spinner"></div>}
                <img
                  src={Banner}
                  alt=""
                  onLoad={() => handleImageLoad(Banner)}
                  style={loadedImages[Banner] ? {} : { visibility: 'hidden' }}
                />
            </div>
            <div className="timetable">
                {/* <div className='title'>{t('opening-hours')}</div>
                <div className='time'>
                    <span>{t('tue-thu')}</span>
                    <span>{t('fri-sat')}</span>
                    <span>{t('sunday')}</span>
                    <span>{t('monday')}</span>
                </div> */}
            </div>
            <ButtonLink to={`/${lang}/reservation`} className="btn-menu btn-with-borders">
                <span>{t('reservation')}</span>
            </ButtonLink>
        </div>
    )
}

export default Contacts; 